import { usePropertyField } from '../usePropertyField';
import { IApplicationRental } from '@apply/api/src/api/ApplyApi';

// ─── Rental – Units ───────────────────────────────────────────────────────────

export const usePropertyRentalNumberUnits = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.rental?.numberRentalUnits,
        (p, v) => ({ ...p, rental: { ...(p.rental ?? {}), numberRentalUnits: v } as IApplicationRental }));

export const usePropertyRentalUnitsIncomeRestricted = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.rental?.unitsIncomeRestricted,
        (p, v) => ({ ...p, rental: { ...(p.rental ?? {}), unitsIncomeRestricted: v } as IApplicationRental }));

export const usePropertyRentalProvideUnitsLater = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.rental?.provideRentalUnitsLater,
        (p, v) => ({ ...p, rental: { ...(p.rental ?? {}), provideRentalUnitsLater: v } as IApplicationRental }));
